var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CategoryCard',{attrs:{"title":_vm.$t('PORTAL.POPULAR_ARTICLES'),"articles":_vm.articles.slice(0, 6)},on:{"viewAll":function($event){return _vm.$emit('viewAll')},"view":_vm.onArticleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }